module.exports = __webpack_public_path__ + "static/media/hero_logo.895dd5a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/hero_logo.png
// module id = 608
// module chunks = 0